import { BehaviorSubject, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigService } from '@shared/services/config.service';
import { LanguageCode } from 'iso-639-1';
import { SelectItem } from 'src/models/general/select.item.model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AvailableLanguage } from '@shared/models/config/l10nConfig';


@Injectable({
	providedIn: 'root'
})
export class LanguageService {
	private defaultLanguage!: LanguageCode;
	private availableLanguages!: AvailableLanguage[];

	private currentContentLanguage!: BehaviorSubject<LanguageCode>;

	private languageSelectItemList!: SelectItem[];

	constructor(private configService: ConfigService, private fb: UntypedFormBuilder) {
		this.initDefaultAndAvailableLanguages();
		this.initLanguageSelectItems();
		this.initCurrentContentLanguageSubject();
	}

	getAvailableLanguagesAsSelectItems(): Observable<SelectItem[]> {
		return of(this.languageSelectItemList);
	}

	getContentLanguageObservable(): Observable<LanguageCode> {
		return this.currentContentLanguage.asObservable();
	}

	getCurrentContentLanguage(): LanguageCode {
		return this.currentContentLanguage.value;
	}

	getContentLanguageForm(): UntypedFormGroup {
		return this.fb.group({
			contentLanguage: [this.getCurrentContentLanguage()]
		});
	}

	updateContentLanguage(formValue: LanguageCode): void {
		this.currentContentLanguage.next(formValue);
	}

	private initDefaultAndAvailableLanguages(): void {
		const config = this.configService.getConfig();
		this.defaultLanguage = config.l10n.defaultLanguage;
		this.availableLanguages = config.l10n.availableLanguages;
	}

	private initLanguageSelectItems(): void {
		this.languageSelectItemList = [];
		this.availableLanguages.map((lang: AvailableLanguage) => {
			this.languageSelectItemList.push({id: lang.code, value: lang.germanName});
		});
	}

	private initCurrentContentLanguageSubject(): void {
		this.currentContentLanguage = new BehaviorSubject<LanguageCode>(this.defaultLanguage);
	}
}

